import styled from 'styled-components'

const Button = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  
  &:focus {
    outline: none;
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/components/Common/Button.js